module.exports = __webpack_public_path__ + "static/sport/icon-3.bf83034.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/september10/icon-3.png
// module id = JJc8
// module chunks = 0